import React from 'react';

interface Props {
  color: string;
  width?: string;
  height?: string;
}

export const EmailOutlineIcon: React.SFC<Props> = ({ color }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 2H15.5V0H13.5V2H5.5V0H3.5V2H2.5C1.96957 2 1.46086 2.21071 1.08579 2.58579C0.710714 2.96086 0.5 3.46957 0.5 4V18C0.5 18.5304 0.710714 19.0391 1.08579 19.4142C1.46086 19.7893 1.96957 20 2.5 20H7.5V18H2.5V7H16.5V8H18.5V4C18.5 3.46957 18.2893 2.96086 17.9142 2.58579C17.5391 2.21071 17.0304 2 16.5 2ZM19.2 12.35L18.2 13.35L16.15 11.35L17.15 10.35C17.35 10.14 17.69 10.13 17.92 10.35L19.2 11.63C19.39 11.83 19.39 12.15 19.2 12.35ZM9.5 17.94L15.57 11.88L17.62 13.88L11.56 20H9.5V17.94Z"
      fill={color}
    />
  </svg>
);

export const SwapHorizontalIcon: React.SFC<Props> = ({ color, width, height }) => (
  <svg
    width={width || '40'}
    height={height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill={color} />
    <path d="M16 18V21H22V26H16V29L10 23.5L16 18ZM30 16.5L24 11V14H18V19H24V22L30 16.5Z" fill="white" />
  </svg>
);

export const LockClockIcon: React.SFC<Props> = ({ color, width, height }) => (
  <svg
    width={width || '40'}
    height={height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill={color} />
    <path
      d="M16.5 10C14 10 12 12 12 14.5V15C10.89 15 10 15.89 10 17V26C10 27.11 10.89 28 12 28H16.72C18.18 29.29 20.06 30 22 30C24.1217 30 26.1566 29.1571 27.6569 27.6569C29.1571 26.1566 30 24.1217 30 22C30 19.8783 29.1571 17.8434 27.6569 16.3431C26.1566 14.8429 24.1217 14 22 14C21.66 14 21.32 14.03 21 14.08C20.76 11.77 18.82 10 16.5 10ZM16.5 12C17.163 12 17.7989 12.2634 18.2678 12.7322C18.7366 13.2011 19 13.837 19 14.5V15H14V14.5C14 13.837 14.2634 13.2011 14.7322 12.7322C15.2011 12.2634 15.837 12 16.5 12ZM22 16C23.5913 16 25.1174 16.6321 26.2426 17.7574C27.3679 18.8826 28 20.4087 28 22C28 23.5913 27.3679 25.1174 26.2426 26.2426C25.1174 27.3679 23.5913 28 22 28C20.4087 28 18.8826 27.3679 17.7574 26.2426C16.6321 25.1174 16 23.5913 16 22C16 20.4087 16.6321 18.8826 17.7574 17.7574C18.8826 16.6321 20.4087 16 22 16ZM21 18V23L24.64 25.19L25.42 23.9L22.5 22.15V18H21Z"
      fill="white"
    />
  </svg>
);

export const CalendarAlertIcon: React.SFC<Props> = ({ color, width, height }) => (
  <svg
    width={width || '40'}
    height={height || '40'}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill={color} />
    <path
      d="M14 9V11H13C11.89 11 11 11.89 11 13V27C11 27.5304 11.2107 28.0391 11.5858 28.4142C11.9609 28.7893 12.4696 29 13 29H27C28.11 29 29 28.11 29 27V13C29 12.4696 28.7893 11.9609 28.4142 11.5858C28.0391 11.2107 27.5304 11 27 11H26V9H24V11H16V9H14ZM13 16H27V27H13V15V16ZM19 17V22H21V17H19ZM19 24V26H21V24H19Z"
      fill="white"
    />
  </svg>
);

export const CalendarClockIcon: React.SFC<Props> = ({ color }) => (
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 12H13.5V14.82L15.94 16.23L15.19 17.53L12 15.69V12ZM16 7H2V18H6.67C6.24 17.09 6 16.07 6 15C6 13.1435 6.7375 11.363 8.05025 10.0503C9.36301 8.7375 11.1435 8 13 8C14.07 8 15.09 8.24 16 8.67V7ZM2 20C1.46957 20 0.960859 19.7893 0.585786 19.4142C0.210714 19.0391 0 18.5304 0 18V4C0 2.89 0.89 2 2 2H3V0H5V2H13V0H15V2H16C16.5304 2 17.0391 2.21071 17.4142 2.58579C17.7893 2.96086 18 3.46957 18 4V10.1C19.24 11.36 20 13.09 20 15C20 16.8565 19.2625 18.637 17.9497 19.9497C16.637 21.2625 14.8565 22 13 22C11.09 22 9.36 21.24 8.1 20H2ZM13 10.15C11.7137 10.15 10.4801 10.661 9.57053 11.5705C8.66098 12.4801 8.15 13.7137 8.15 15C8.15 17.68 10.32 19.85 13 19.85C13.6369 19.85 14.2676 19.7246 14.856 19.4808C15.4444 19.2371 15.9791 18.8798 16.4295 18.4295C16.8798 17.9791 17.2371 17.4444 17.4808 16.856C17.7246 16.2676 17.85 15.6369 17.85 15C17.85 12.32 15.68 10.15 13 10.15Z"
      fill={color}
    />
  </svg>
);

export const GroupIcon: React.SFC<Props> = ({ color, width, height }) => (
  <svg width={width} height={height} viewBox="0 0 18 11" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0.125C9.69619 0.125 10.3639 0.401562 10.8562 0.893845C11.3484 1.38613 11.625 2.05381 11.625 2.75C11.625 3.44619 11.3484 4.11387 10.8562 4.60616C10.3639 5.09844 9.69619 5.375 9 5.375C8.30381 5.375 7.63613 5.09844 7.14384 4.60616C6.65156 4.11387 6.375 3.44619 6.375 2.75C6.375 2.05381 6.65156 1.38613 7.14384 0.893845C7.63613 0.401562 8.30381 0.125 9 0.125ZM3.75 2C4.17 2 4.56 2.1125 4.8975 2.315C4.785 3.3875 5.1 4.4525 5.745 5.285C5.37 6.005 4.62 6.5 3.75 6.5C3.15326 6.5 2.58097 6.26295 2.15901 5.84099C1.73705 5.41903 1.5 4.84674 1.5 4.25C1.5 3.65326 1.73705 3.08097 2.15901 2.65901C2.58097 2.23705 3.15326 2 3.75 2ZM14.25 2C14.8467 2 15.419 2.23705 15.841 2.65901C16.2629 3.08097 16.5 3.65326 16.5 4.25C16.5 4.84674 16.2629 5.41903 15.841 5.84099C15.419 6.26295 14.8467 6.5 14.25 6.5C13.38 6.5 12.63 6.005 12.255 5.285C12.9089 4.44081 13.2124 3.37715 13.1025 2.315C13.44 2.1125 13.83 2 14.25 2ZM4.125 9.6875C4.125 8.135 6.3075 6.875 9 6.875C11.6925 6.875 13.875 8.135 13.875 9.6875V11H4.125V9.6875ZM0 11V9.875C0 8.8325 1.4175 7.955 3.3375 7.7C2.895 8.21 2.625 8.915 2.625 9.6875V11H0ZM18 11H15.375V9.6875C15.375 8.915 15.105 8.21 14.6625 7.7C16.5825 7.955 18 8.8325 18 9.875V11Z"
      fill={color}
    />
  </svg>
);

export const ArticleIcon: React.SFC<Props> = ({ color }) => (
  <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.9592 14H4.97957V12H11.9592V14ZM14.9505 10H4.97957V8H14.9505V10ZM14.9505 6H4.97957V4H14.9505V6ZM16.9446 0H2.98539C1.87862 0 0.991211 0.89 0.991211 2V16C0.991211 16.5304 1.20131 17.0391 1.57529 17.4142C1.94927 17.7893 2.4565 18 2.98539 18H16.9446C17.4735 18 17.9808 17.7893 18.3547 17.4142C18.7287 17.0391 18.9388 16.5304 18.9388 16V2C18.9388 1.46957 18.7287 0.960859 18.3547 0.585786C17.9808 0.210714 17.4735 0 16.9446 0Z"
      fill={color}
    />
  </svg>
);

export const HourglassIcon: React.SFC<Props> = ({ color }) => (
  <svg width="12" height="20" viewBox="0 0 12 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 0H12V6L8 10L12 14V20H0V14L4 10L0 6V0ZM10 14.5L6 10.5L2 14.5V18H10V14.5ZM6 9.5L10 5.5V2H2V5.5L6 9.5ZM4 4H8V4.75L6 6.75L4 4.75V4Z"
      fill={color}
    />
  </svg>
);

export const AddToCalendarIcon: React.SFC<Props> = ({ color }) => (
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.6797 17.5V6.67969H2.32031V17.5H15.6797ZM15.6797 2.5C16.1224 2.5 16.5 2.66927 16.8125 3.00781C17.151 3.34635 17.3203 3.73698 17.3203 4.17969V17.5C17.3203 17.9427 17.151 18.3333 16.8125 18.6719C16.5 19.0104 16.1224 19.1797 15.6797 19.1797H2.32031C1.8776 19.1797 1.48698 19.0104 1.14844 18.6719C0.835938 18.3333 0.679688 17.9427 0.679688 17.5V4.17969C0.679688 3.73698 0.835938 3.34635 1.14844 3.00781C1.48698 2.66927 1.8776 2.5 2.32031 2.5H3.17969V0.820312H4.82031V2.5H13.1797V0.820312H14.8203V2.5H15.6797Z"
      fill={color}
    />
    <circle cx="15" cy="17" r="5" fill="white" />
    <path
      d="M17.0898 17.4102V16.5898H15.4102V14.9102H14.5898V16.5898H12.9102V17.4102H14.5898V19.0898H15.4102V17.4102H17.0898ZM12.0508 14.0703C12.8711 13.25 13.8542 12.8398 15 12.8398C16.1458 12.8398 17.1224 13.25 17.9297 14.0703C18.75 14.8776 19.1602 15.8542 19.1602 17C19.1602 18.1458 18.75 19.1289 17.9297 19.9492C17.1224 20.7565 16.1458 21.1602 15 21.1602C13.8542 21.1602 12.8711 20.7565 12.0508 19.9492C11.2435 19.1289 10.8398 18.1458 10.8398 17C10.8398 15.8542 11.2435 14.8776 12.0508 14.0703Z"
      fill={color}
    />
  </svg>
);

export const FixAdjustmentIcon: React.SFC<Props> = ({ color }) => (
  <svg width="43" height="40" viewBox="0 0 43 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M23.3594 22.3594V25.6406H11.6406V22.3594H23.3594ZM31.6406 30.6406V12.3594H8.35938V30.6406H31.6406ZM31.6406 4C32.526 4 33.3073 4.33854 33.9844 5.01562C34.6615 5.69271 35 6.47396 35 7.35938V30.6406C35 31.526 34.6615 32.3073 33.9844 32.9844C33.3073 33.6615 32.526 34 31.6406 34H8.35938C7.42188 34 6.61458 33.6875 5.9375 33.0625C5.3125 32.3854 5 31.5781 5 30.6406V7.35938C5 6.47396 5.3125 5.69271 5.9375 5.01562C6.61458 4.33854 7.42188 4 8.35938 4H10V0.640625H13.3594V4H26.6406V0.640625H30V4H31.6406ZM28.3594 15.6406V19H11.6406V15.6406H28.3594Z"
      fill={color}
    />
    <circle cx="33" cy="30" r="10" fill="white" />
    <path
      d="M31.3203 34.1797L38.8203 26.6797L37.6484 25.4688L31.3203 31.7969L28.3516 28.8281L27.1797 30L31.3203 34.1797ZM27.1016 24.1406C28.7422 22.5 30.7083 21.6797 33 21.6797C35.2917 21.6797 37.2448 22.5 38.8594 24.1406C40.5 25.7552 41.3203 27.7083 41.3203 30C41.3203 32.2917 40.5 34.2578 38.8594 35.8984C37.2448 37.513 35.2917 38.3203 33 38.3203C30.7083 38.3203 28.7422 37.513 27.1016 35.8984C25.487 34.2578 24.6797 32.2917 24.6797 30C24.6797 27.7083 25.487 25.7552 27.1016 24.1406Z"
      fill={color}
    />
  </svg>
);
